export function addAtIndex<T>(array: T[], item: T, index: number) {
  array.splice(index, 0, item);
}
